<template>
  <b-container>
    <config-publisher
      ref="configPublisher"
      v-model="config"
      class="p-0"
      tool-name="Messages Configuration"
      :config-name="configName"
      :can-edit="canMessagesEdit"
      :can-publish="canMessagesPublish">
      <message-form
        v-if="config"
        ref="messageform"
        :config="config" />
    </config-publisher>
  </b-container>
</template>

<script>
import {mapGetters} from "vuex"
import ConfigPublisher from "@/components/ConfigPublisher"
import MessageForm from "@/components/Messages/MessageForm"

export default {
  name: "MessagesVue",
  components: {
    ConfigPublisher,
    MessageForm,
  },
  data: () => ({
    config: {},
    configName: 'messages',
  }),
  computed: {
    ...mapGetters([
      'betaEnvName',
      'liveEnvName',
      'canMessagesEdit',
      'canMessagesPublish',
    ]),
  },
  async beforeRouteLeave(to, from, next) {
    if (this.$refs.configPublisher.configHasChanged()) {
      const message = `You have unpublished changes to your config, which will be lost.\n\nClick "Cancel" to go back and publish your work, or click "Yes" to lose your changes.`
      next(await this.$confirm.open(message))
    } else {
      next()
    }
  },
}
</script>

<style scoped>

</style>